import React from "react"
import { CustomBox } from "../../../../../ui/spacings"
import { BrandTagItems } from "./BrandTagItems"
import { CategoryTagItems } from "./CategoryTagItems"
import { DiscountTagItems } from "./DiscountTagItems"
import { FilterTagItems } from "./FilterTagItems"

export const CurrentFilterTags = () => {
  return (
    <CustomBox flex="row" flexWrap>
      <DiscountTagItems />
      <BrandTagItems />
      <CategoryTagItems />
      <FilterTagItems />
    </CustomBox>
  )
}
